<!--table starts-->
<div class="subheader with-padding flgrow">
    <div class="row align-items-center">
        <div class="col-6 col-lg-3">
            <div class="d-flex">
                <div class="flex-grow-1">
                    <div class="input-group">
                        <input class="form-control" type="text" name="searchTerm"
                            placeholder="{{ 'lblSearch' | translate }}" [(ngModel)]="searchTerm" autocomplete="off"
                            (keyup.enter)="onSearchFilter()" />
                        <div class="input-group-append">
                            <button type="button" class="btn btn-primary" (click)="onSearchFilter()">
                                <em class="fa fa-search"></em>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="ml-2 advanced-search-box">
                    <button type="button" class="btn btn-primary" (click)="onSearch()" aria-label="Center Align">
                        <em class="fa fa-search-plus" aria-hidden="true"></em>
                    </button>
                    <div class="searchbox card fix lt" *ngIf="isAdvanceSearch">
                        <div class="form-row mt-3 mb-3">
                            <div class="col">
                                <label for="template-licensePlate" translate>lblRegNumber </label>
                                <div class='lbl-info'>
                                    <input type="text" id="template-licensePlate" name="licensePlate"
                                        [(ngModel)]="vehicleListRequest.licensePlate" class="form-control"
                                        placeholder="" maxlength="50">
                                </div>
                            </div>
                            <div class="col">
                                <label for="template-vehiclegroup" translate>lblVehicleStatus</label>
                                <div class='lbl-info'>
                                    <ng-select placeholder="{{ 'lblSelectVehicleStatus' | translate }}"
                                        [(ngModel)]="vehicleListRequest.vehicleGroup">
                                        <ng-option *ngFor="let type of vehicleStatusList" [value]="type.vehicleStatus">
                                            {{type.vehicleStatus}}</ng-option>
                                    </ng-select>
                                </div>
                            </div>
                            <div class="col">
                                <label for="template-vehicletype" translate>lblVehicalType </label>
                                <div class='lbl-info'>
                                    <ng-select placeholder="{{ 'lblSelectVehical' | translate }}"
                                        [(ngModel)]="vehicleListRequest.vehicleType">
                                        <ng-template ng-header-tmp>
                                            <span class="mbold w-66px">Code</span>
                                            <span class="mbold" translate>lblVehicalType</span>
                                        </ng-template>

                                        <ng-option *ngFor="let item of vehicleTypes" [value]="item.code">
                                            <span class="w-66px">{{item.code}}</span>
                                            <span class="mx-2 hide-ng-dropdown-panel">-</span>
                                            <span>{{item.name}}</span>
                                        </ng-option>
                                    </ng-select>
                                </div>
                            </div>
                        </div>
                        <div class="form-row mb-3">
                            <div class="col">
                                <label for="template-make" translate>lblMake</label>
                                <div class='lbl-info'>
                                    <ng-select placeholder="{{ 'lblSelectMake' | translate }}"
                                        [(ngModel)]="vehicleListRequest.companyMakeName">
                                        <ng-option *ngFor="let type of makeList" [value]="type.brandCode">
                                            {{type.brandCode}}</ng-option>
                                    </ng-select>
                                </div>
                            </div>
                            <div class="col">
                                <label for="template-chassisNo" translate="">lblVinNumber</label>
                                <div class="lbl-info">
                                    <input type="text" id="template-chassisNo" name="chassisNo"
                                        [(ngModel)]="vehicleListRequest.chassisNo" autocomplete="off"
                                        class="form-control" placeholder="{{ 'lblEnterVIN' | translate }}"
                                        maxlength="25">
                                </div>
                            </div>
                            <div class="col">
                                <label for="txtregistrationFirstDate" translate>lblRegistrationFirstDate</label>
                                <div class="lbl-info cal-date">
                                    <input class="form-control datePicker width100force" appAfDatepicker
                                        autocomplete="off" [(ngModel)]="vehicleListRequest.registrationDate"
                                        [startDate]="'1900/01/01'" [dateTime]="false" id="txtregistrationFirstDate"
                                        name="registrationFirstDate" type="text" value="" [endDate]="endDate">
                                    <em class="fas fa-calendar-alt fa-lg cursordisable"></em>
                                </div>
                            </div>
                        </div>
                        <div class="form-row mb-3">
                            <div class="col">
                                <label for="template-source" translate>lblSource</label>
                                <div class='lbl-info'>
                                    <ng-select placeholder="{{ 'lblSource' | translate }}"
                                        [(ngModel)]="vehicleListRequest.sourceOfCreation">
                                        <ng-option *ngFor="let type of applicationSourceList" [value]="type.sourceName">
                                            {{type.sourceName}}</ng-option>
                                    </ng-select>
                                </div>
                            </div>
                            <div class="col">
                                <label for="template-color" translate="">lblColor</label>
                                <div class="lbl-info">
                                    <input type="text" id="template-color" name="color" class="form-control"
                                        [(ngModel)]="vehicleListRequest.color"
                                        placeholder="{{ 'lblEnterColorName' | translate }}" maxlength="20">
                                </div>
                            </div>
                            <div class="col">
                                <label for="template-fueltype" translate>lblFuelType</label>
                                <div class='lbl-info'>
                                    <ng-select placeholder="{{ 'lblSelectFuelType' | translate }}"
                                        [(ngModel)]="vehicleListRequest.fuelType">
                                        <ng-option *ngFor="let type of fuels" [value]="type.fuelType">
                                            {{type.fuelType}}</ng-option>
                                    </ng-select>
                                </div>
                            </div>

                        </div>
                        <div class="form-row mb-3">
                            <div class="col">
                                <label for="template-vehicleTransmission" translate>lblTransmission</label>
                                <div class='lbl-info'>
                                    <ng-select placeholder="{{ 'lblSelectTransmission' | translate }}"
                                        [(ngModel)]="vehicleListRequest.transmission">
                                        <ng-option *ngFor="let type of vehicleTransmissionList" [value]="type.code">
                                            {{type.transmisionName}}</ng-option>
                                    </ng-select>
                                </div>
                            </div>
                            <div class="col">
                                <label for="template-year" translate="">lblYear</label>
                                <div class="lbl-info">
                                    <input type="text" id="template-year" name="year" class="form-control"
                                        [(ngModel)]="vehicleListRequest.year" autocomplete="off"
                                        placeholder="{{ 'lblYearValid' | translate }}" required maxlength="4"
                                        (keypress)="isDigit($event)">
                                </div>
                            </div>
                            <div class="col">

                            </div>
                        </div>
                        <hr />
                        <div class="row">
                            <div class="col text-right">
                                <button type="submit" aria-label="Center Align"
                                    (click)="OpenSaveSearchModal(SaveSearchContent)" class="btn btn-primary mr-sm-3"
                                    translate>lblSaveFilter
                                </button>
                                <button type="submit" class="btn btn-primary mr-sm-3" (click)="AdvanceSearchSubmit()"
                                    translate>lblApply
                                </button>
                                <button (click)="onReset()" class="btn btn-outline-tertiary mr-sm-3" translate>lblReset
                                </button>
                                <button (click)="onClose()" class="btn btn-outline-tertiary" translate>lblClose
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-auto pl-0">
            <button type="submit" (click)="OpenSavedSearchListPopup()" class="btn btn-primary mr-sm-2" translate
                aria-label="Center Align">lblSavedFilters</button>
        </div>

        <div class="col-lg-2 col-md-3 col-sm-6 pl-4" *ngIf="integrationWithDMS">
            <ng-select placeholder="{{ 'lblDMSStatus' | translate }}" [(ngModel)]="selectedSync"
                (change)="SyncChange($event)">
                <ng-option *ngFor="let status of SyncList" [value]="status.id">
                    {{status.value}}
                </ng-option>
            </ng-select>
        </div>
        <div class="col-lg-2 col-md-3 col-sm-6">

        </div>
        <div class="col-3 col-lg-3 ml-auto d-flex flex-sm-row flex-column justify-content-end">
            <a class="ml-2 btn btn-outline-primary" href="javascript:void(0);" (click)="onRefresh()"
                aria-label="Center Align">
                <em class="fas fa-sync fa-lg"></em>
            </a>
        </div>
    </div>
</div>

<div class="container prel">
    <div class="row">
        <div class="c12">
            <div class="card mb-3">
                <div class="card-header d-flex justify-content-between" translate>
                    lblDeletedVehicle
                    <div class="font16 fontbold">
                        <span class="font16 fontnormal" translate>lblTotal</span>:&nbsp;{{
                        totalCount
                        }}&nbsp;<span class="font16 fontnormal" translate>lblResults</span>
                    </div>
                </div>
                <div class="table-responsive max-h232" infinite-scroll [infiniteScrollDistance]="scrollDistance"
                    [infiniteScrollThrottle]="throttle" [scrollWindow]="false" (scrolled)="onScrollDown($event)">
                    <table class="tablest1">
                        <thead>
                            <tr>
                                <th style="width: 55px" scope="col">#</th>
                                <th style="width: 20%" scope="col" sortable="licensePlate" (sort)="onSort($event)"
                                    translate>
                                    lblRegNumber
                                </th>
                                <th style="width: 15%" scope="col" sortable="vehicleGroup" (sort)="onSort($event)"
                                    translate>
                                    lblVehicleStatus
                                </th>
                                <th style="width: 8%" scope="col" sortable="vehicleType" (sort)="onSort($event)"
                                    translate>lblType</th>
                                <th style="width: 10%" scope="col" sortable="registrationDate" (sort)="onSort($event)"
                                    translate>
                                    lbl1stRegistrationDate
                                </th>
                                <th style="width: 10%" scope="col" sortable="chassisNo" (sort)="onSort($event)"
                                    translate>lblVinNumber
                                </th>
                                <th style="width: 15%" scope="col" sortable="fuelType" (sort)="onSort($event)"
                                    translate>
                                    lblFuelType
                                </th>
                                <th scope="col" style="width:50px" sortable="dmsSyncDate" (sort)="onSort($event)"
                                    translate *ngIf="integrationWithDMS">lbllastSyncdate</th>
                                <th style="width: 5%" scope="col" translate>
                                    lblSource
                                </th>
                                <th style="width: 75px" scope="col" class="text-center" translate>
                                    lblAction
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngIf="vehicleList?.length > 0; else load_else">
                                <tr *ngFor="let vehicle of vehicleList; let i = index"
                                    [ngClass]="{'text-danger' : vehicle.dmsSyncStatus == 0}">
                                    <td>{{ vehicle.rowNumber }}</td>
                                    <td>
                                        <div class="flmid">
                                            <div class="licplate LPNo d-flex">
                                                <span class="icn-flag" [ngClass]="licensePlateClass"></span>
                                                {{ vehicle.licensePlate }}
                                            </div>
                                            <div class="imgWid">
                                                <img af-brand-logo [data-code]="vehicle.companyMakeCode" data-type="BRAND"
                                                    class="{{ vehicle.companyMakeCode }}-icon brandicon"
                                                    alt="{{vehicle.companyMakeName}}" />
                                            </div>
                                        </div>
                                        <div class="mt-1">
                                            <ngb-highlight [result]="vehicle.companyModel"
                                                class="flmid semibold fs-12px lh-16px">
                                            </ngb-highlight>
                                        </div>
                                    </td>
                                    <td>
                                        <ngb-highlight [result]="vehicle.vehicleGroup"></ngb-highlight>
                                    </td>
                                    <td>
                                        <ngb-highlight [result]="vehicle.vehicleType">
                                        </ngb-highlight>
                                    </td>
                                    <td>
                                        <ngb-highlight result="{{ vehicle.registrationDate }}"></ngb-highlight>
                                    </td>
                                    <td>
                                        <ngb-highlight [result]="vehicle.chassisNo">
                                        </ngb-highlight>
                                    </td>
                                    <td>
                                        <ngb-highlight [result]="vehicle.fuelType"> </ngb-highlight>
                                    </td>
                                    <td *ngIf="integrationWithDMS">
                                        {{ vehicle.dmsSyncDate | date:'short'}}
                                    </td>
                                    <td>
                                        <ngb-highlight
                                            [ngClass]="vehicle.sourceOfCreation ? 'flmid sourceBox rounded-0 justify-content-center' : ''"
                                            [result]="vehicle.sourceOfCreation">
                                        </ngb-highlight>
                                    </td>

                                    <td class="nowrap text-center">
                                        <a class="btn btn-ico "
                                            *ngIf="userRoleRightsDetails?.canDelete  else disabledDelete"
                                            (click)="HardDeleteVehicle(vehicle.vehicleId)"
                                            ngbTooltip="{{'lblDelete' | translate}}" tooltipClass="custom-revert">
                                            <em class="far fa-trash-alt fa-lg"></em>
                                        </a>
                                        <ng-template #disabledDelete>
                                            <a class="btn btn-ico disabled" ngbTooltip="{{'lblDelete' | translate}}"
                                                tooltipClass="custom-revert">
                                                <em class="far fa-trash-alt fa-lg text-muted"></em>
                                            </a>
                                        </ng-template>
                                    </td>

                                </tr>
                            </ng-container>
                            <ng-template #load_else>
                                <tr>
                                    <td colspan="8" class="no-record" translate>
                                        lblNoRecordsFound
                                    </td>
                                </tr>
                            </ng-template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
<ng-template #SaveSearchContent let-modal>
    <div class="modal-header">
        <h2 class="modal-title" translate>lblSaveFilter</h2>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss(false)">

            <span aria-hidden="true">×</span>
        </button>
    </div>
    <div class="modal-body p-0 ">
        <div class="popup-vcenter ">
            <div class="flgrow">
                <div class="pad15">
                    <div class="form-row">
                        <div class='col-5'>
                            <label translate>lblSearchName</label><strong class="mlt6 required"> * </strong>
                            <div class="">
                                <input class="form-control" type="text" name="SearchName" [formControl]="control"
                                    [(ngModel)]="saveSearchFilter.filterName" maxlength="200" autocomplete="off"
                                    placeholder="{{ 'lblEnterSearchName' | translate }}" />
                                <div *ngIf="!saveSearchFilter.filterName && control.touched" style="color: red;"
                                    class="cst-validation-msg">
                                    <em class="fa fa-exclamation-circle" aria-hidden="true">&nbsp;&nbsp;</em><span
                                        translate>lblSearchNameRequired</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div class="form-row">
                        <div class="col-12">
                            <p class="title16 mb-2" translate>lblParameterValues</p>
                            <div class="row">
                                <div class='col-4 mb-2' *ngFor="let search of saveSearchFilter.saveSearchArray">
                                    <div class="px-3">
                                        <em class="fa fa-chevron-right mr-2"></em>
                                        <span class="bold">{{search.searchColumnName | translate}}</span> :
                                        {{search.searchActualValue}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal-footer">
        <button type="submit" [disabled]="!saveSearchFilter.filterName" class="btn btn-primary mr-sm-2" translate
            (click)="control.markAsTouched();SaveAdvanceSearchFilter();" aria-label="Center Align">lblSave</button>
        <button (click)="modal.dismiss(false)" class="btn btn-secondary" aria-label="Center Align"
            translate>lblCancel</button>
    </div>
</ng-template>